import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { DateTime } from 'luxon';
import { initReactI18next } from 'react-i18next';
import { getDateTime } from '../helpers/date';
import resources from './lang';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
      format: function (value, format) {
        if (format === 'Date')
          return getDateTime(value).toLocaleString(DateTime.DATE_SHORT);

        if (value instanceof Date) {
          return DateTime.fromJSDate(value)
            .setLocale(format)
            .toLocaleString(DateTime.DATETIME_SHORT);
        }
        return value;
      },
    },
    resources,
  });

export default i18n;
